/** Strips spaces, keeps letters, digits and dashes, uppercases; recovery codes look like `K7QM-2XPA-R9TD`. */
export function normalizeTwoStepCode(input: string): string {
  return input
    .replace(/\s+/g, '')
    .replace(/[^0-9A-Za-z-]/g, '')
    .toUpperCase()
    .slice(0, 14);
}

/** A 6-digit code from an authenticator app. */
export function isAuthenticatorCode(code: string): boolean {
  return /^\d{6}$/.test(code);
}

/** A 6-digit authenticator code, or a 12-character recovery code with or without dashes. */
export function isTwoStepCode(code: string): boolean {
  if (isAuthenticatorCode(code)) return true;
  return /^[0-9A-Z]{12}$/.test(code.replace(/-/g, ''));
}
